import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'
import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import { useEnvironmentUpdateMutation } from 'hooks/mutations/org'
import { environmentRoute } from 'pages/NWPlatform'
import { manageAccessRoute } from 'pages/NWPlatform/Environment/Routing'
import { environmentQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages'])

  const { environmentId } = environmentRoute.useParams()

  const environmentQuery = useQuery(environmentQueryKeys.detail({ environmentId }))
  const environment = environmentQuery.data

  const { mutate: updateEnvironment, ...environmentUpdateMutation } = useEnvironmentUpdateMutation()

  const handleUpdateEnvironmentName = useCallback(
    (title: string, closeCallback: () => void) => {
      if (environment) {
        updateEnvironment(
          {
            environmentId,
            orgEnvironmentEdit: {
              name: title,
            },
          },
          {
            onError: () => enqueueSnackbar(t('pages:EnvironmentSetting.updateError')),
            onSettled: closeCallback,
          },
        )
      }
    },
    [t, environment, updateEnvironment, environmentId],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={environmentQuery.data?.name ?? ''}
          isLoading={environmentQuery.isLoading}
          isSaving={environmentUpdateMutation.isPending}
          onSave={handleUpdateEnvironmentName}
        />
      }
      SubNavigation={
        <Tabs>
          <NavigationTabLink
            from={environmentRoute.fullPath}
            to={manageAccessRoute.to}
            activeOptions={{ exact: false }}
          >
            {t('pages:Environment.permissions')}
          </NavigationTabLink>
        </Tabs>
      }
    />
  )
}

export const Structure = memo(StructureRaw)
